import { createContext, useState, useContext, useEffect } from 'react';

const EarningsVisibilityContext = createContext(null);

export const EarningsVisibilityProvider = ({ children }) => {
	const [showEarnings, setShowEarnings] = useState(() => {
		// Initialize from localStorage if available
		const saved = localStorage.getItem('showEarnings');
		return saved === null ? true : JSON.parse(saved);
	});

	useEffect(() => {
		// Persist to localStorage whenever state changes
		localStorage.setItem('showEarnings', JSON.stringify(showEarnings));
	}, [showEarnings]);

	const toggleEarningsVisibility = () => {
		setShowEarnings(prev => !prev);
	};

	return (
		<EarningsVisibilityContext.Provider value={{
			showEarnings,
			toggleEarningsVisibility
		}}>
			{children}
		</EarningsVisibilityContext.Provider>
	);
};

export const useEarningsVisibility = () => {
	const context = useContext(EarningsVisibilityContext);
	if (!context) {
		throw new Error('useEarningsVisibility must be used within an EarningsVisibilityProvider');
	}
	return context;
};